export default function Bard() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Bard</h1>
    </div>
  );
}
